export default {
  timeEntries: "Time Entries",
  timeEntry: "Time Entry",
  date: "Date",
  project: "Project",
  duration: "Duration",
  description: "Description",
  member: "Member",
  memberRole: "Role",
  contributor: "Contributor",
  deleteSuccess: "Time entry deleted successfully",
  deleteSuccess_plural: "Time entries deleted successfully",
  confirmDeleteTitle: "Delete Time Entry",
  confirmDeleteTitle_plural: "Delete Time Entries",
  confirmDeleteMessage: "Are you sure you want to delete this time entry?",
  confirmDeleteMessage_plural:
    "Are you sure you want to delete these {{count}} time entries?",
  deleteError:
    "Sorry, this time entry could not be deleted due to an error on our end. Please try again later.",
  noDescription: "No description",
  filterByProject: "Project",
  filterByMember: "Member",
  filterByDate: "Date",
  thisWeek: "This week",
  lastWeek: "Last week",
  thisMonth: "This month",
  lastMonth: "Last month",
  customRange: "Custom range",
  from: "From",
  to: "To",
  clearFilters: "Clear Filters",
  addFilter: "Add Filter",
  allMembers: "All Members",
  allProjects: "All Projects",
  is: "is",
  addTimeEntry: "Add Time Entry",
  editTimeEntry: "Edit Time Entry",
  timeLoggedTitle: "Time logged",
  createSuccess: "Time entry created successfully",
  funConfirmations: {
    "1": "You're awesome — time logged.",
    "2": "Boom — that's another one in the books.",
    "3": "Logged it. Future you says thanks.",
    "4": "Time captured. Onwards!",
    "5": "Look at you, staying on top of it.",
    "6": "Nice. That'll come in handy on the invoice.",
    "7": "Logged. Treat yourself to a coffee.",
    "8": "And that's a wrap on those minutes.",
    "9": "Saved. Your future invoice thanks you.",
    "10": "Time well tracked.",
  },
  updateSuccess: "Time entry updated successfully",
  hours: "Hours",
  minutes: "Minutes",
  hoursRange: "Hours must be between 0 and 23",
  minutesRange: "Minutes must be between 0 and 59",
  durationRequired: "Duration must be greater than 0",
  descriptionMaxLength: "Description must be 1000 characters or less",
  service: "Service",
  rate: "Rate",
  total: "Total",
  addAnother: "Add another",
  logTime: "Log Time",
  locked: "Locked",
  lockedTooltip: "Locked — period has been invoiced",
  lockedWarning: "This entry is locked. You are editing invoiced data.",
  rateLocked: "This rate is locked",
  invoiced: "Invoiced",
  invoicedTooltip: "This entry has been invoiced",
  downloadCsv: "Download CSV",
  exportError:
    "Sorry, this export could not be generated due to an error on our end. Please try again later.",
};
